import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {BdDunningTypeDeadlineDerivationDto} from "../../model/dto/api/bd-dunning-type-deadline-derivation.dto";

@Injectable({providedIn: 'root'})
export class DunningTypeService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bd/dunningTypes')
    }

    /**
     * Loads the resolved deadline/level configuration of a DunningType
     * (Modell-C offsets per level incl. provenance, plus an example date chain
     * for one selectable sample date) for the configuration overview.
     *
     * Backend route: {@code GET /mvsa/bd/dunningTypes/{dunningTypeId}/deadline-derivation}.
     * The date arithmetic (bank working days, holidays, §193 BGB roll) runs
     * exclusively in the backend via {@code BdDunningDeadlineService} /
     * {@code BankCalendarService} — no date arithmetic of its own happens here
     * (Foundational Decision 11.1).
     *
     * @param dunningTypeId id of the DunningType
     * @param referenceDate optional sample date (ISO date, e.g. '2026-09-04');
     *                      if omitted, the backend uses today's date as default
     *
     * @ticket bd-dunningtype-overview
     */
    getDeadlineDerivation(
        dunningTypeId: number,
        referenceDate?: string
    ): Observable<BdDunningTypeDeadlineDerivationDto> {
        let params = new HttpParams();
        if (referenceDate) {
            params = params.set('referenceDate', referenceDate);
        }
        return this.http.get<BdDunningTypeDeadlineDerivationDto>(
            `${this.apiUrl}/${dunningTypeId}/deadline-derivation`, {params});
    }
}
